<template>
	<div class="loadmore">
		<a href="#" @click.prevent="$emit('more')">
			<span v-if="!isLoading">Load More</span>
			<LoadingWheel v-else />
		</a>
	</div>
</template>

<script>
import LoadingWheel from './LoadingWheel.vue';

//
export default {
	components: {
		LoadingWheel
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {}
	},
	computed: {},
	methods: {}
};
</script>

<style lang="scss">
.loadmore {
	position: relative;
	padding: 30px 0;
	text-align: center;

	a {
		display: inline-block;
		min-width: 150px;
		background-color: #cdc7a2;
		line-height: 45px;
		height: 45px;
		text-align: center;
		text-decoration: none;
		font-size: 16px;
		color: #333;
	}

	@media (hover) {
		a {
			&:hover {
				background-color: #e5e0bf;
			}
		}
	}

	@media ( min-width: 480px ) {
	}
}
</style>